/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalBody,
} from "@chakra-ui/modal";
import Card from "components/card";
import { Button } from '@chakra-ui/react';
import { ImSpinner8 } from "react-icons/im";

type FeeGroup = {
    id: string;
    name: string;
    template: any;
};

const AgentFeeGroupDetails: React.FC<{
    feeDetail: any;
    isOpen: boolean;
    onClose(): void;
}> = ({ feeDetail, isOpen, onClose }) => {
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [feeGroupDetail, setFeeGroupDetail] = useState<any>(null);
    const [errorMessage, setErrorMessage] = useState<any>("");

    const getAgentFeeGroupListByAsset = async (asset: any) => {
        try {
            const response = await axios.get(
                process.env.REACT_APP_API_URL +
                `/api/agent/feegroups?asset=${asset}`
            );

            const responseData = response.data?.feeGroups?.payload;
            const matchedFeeGroup = responseData.feegroups.find(
                (fg: any) => fg.feegroup_id === feeDetail.feegroup_id
            );

            const fee: FeeGroup | null = matchedFeeGroup
                ? {
                    id: matchedFeeGroup.feegroup_id,
                    name: matchedFeeGroup.name,
                    template: matchedFeeGroup.feetemplate,
                }
                : null;

            setFeeGroupDetail(fee);
        } catch (error) {
            setErrorMessage("Something went wrong, please try again");
            console.error("Error fetching data", error);
        }
    };

    useEffect(() => {
        const fetchData = async () => {
            setIsLoading(true);
            await getAgentFeeGroupListByAsset(feeDetail.asset);
            setIsLoading(false);
        };

        fetchData();
    }, []); // eslint-disable-line

    const closeModal = async () => {
        onClose();
        setFeeGroupDetail(null);
        setErrorMessage("");
    };

    return (
        <>
            <Modal isOpen={isOpen} onClose={onClose} closeOnOverlayClick={false}>
                <ModalOverlay className="bg-[#000] !opacity-30" />
                <ModalContent className="!z-[1002] !m-auto !w-max min-w-[350px] !max-w-[85%] md:top-[12vh]">
                    <ModalBody className="!text-navy-700">
                        <Card extra="px-[30px] pt-[35px] pb-[40px] max-w-[450px] flex flex-col !z-[1004]">
                            <h1 className="mb-[20px] text-2xl font-bold">Fee Group Details</h1>
                            <div className="mb-[20px] text-sm">
                                {isLoading && (
                                    <div className="flex items-center justify-center">
                                        <ImSpinner8 className="spinner mt-1 details-spinner-color" style={{ fontSize: '2.2rem' }} />
                                    </div>
                                )}
                                {!isLoading &&
                                    <>
                                        <div className="mb-1">
                                            <span>Asset:</span>
                                            <span className="ml-3 font-semibold">
                                                {feeDetail.asset}
                                            </span>
                                        </div>
                                        <div className="mb-1">
                                            <span>Name:</span>
                                            <span className="ml-3 font-semibold">
                                                {feeGroupDetail.name}
                                            </span>
                                        </div>
                                        <div className="mb-1">
                                            <span>Fixed:</span>
                                            <span className="ml-3 font-semibold">
                                                {feeGroupDetail.template.fixed}
                                            </span>
                                        </div>
                                        <div className="mb-1">
                                            <span>Percentage:</span>
                                            <span className="ml-3 font-semibold">
                                                {feeGroupDetail.template.percentage}
                                            </span>
                                        </div>
                                    </>
                                }
                                {errorMessage !== "" &&
                                    <>{errorMessage}</>
                                }
                            </div>
                            {!isLoading &&
                                <div className="flex gap-2 justify-end">
                                    <Button
                                        onClick={() => closeModal()}
                                        className="btn btn-default"
                                    >
                                        Close
                                    </Button>
                                </div>
                            }
                        </Card>
                    </ModalBody>
                </ModalContent>
            </Modal>
        </>
    );
};

export default AgentFeeGroupDetails;
